import * as api from "@/api/williams/testEvents";
import { useQuery } from "react-query";

export function useDefaultEvent() {
  return useQuery("default-event", api.getDefaultValues, {
    cacheTime: 0,
    staleTime: 0,
  });
}
